module.exports = __webpack_public_path__ + "static/img/data_line_orange.559f5b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/statistic/data_line_orange.png
// module id = /HPz
// module chunks = 2